import { useSelector } from 'react-redux';
import { useUpdateEffect } from 'react-use';

import { selectReportOrCurrentProjectId } from 'util/selector/reportSelector';

import { useAppDispatch } from 'reduxStore/appStore';
import { clearDepartments } from 'reduxStore/departments/slice';

export const useClearDepartments = () => {
  const dispatch = useAppDispatch();
  const projectId = useSelector(selectReportOrCurrentProjectId);

  useUpdateEffect(() => {
    if (!projectId) {
      dispatch(clearDepartments());
    }
  }, [projectId, dispatch]);
};
